import React from 'react';

import { IconTypes } from '@eika/icon';
import { LinkCard } from '@eika/link-panel';
import { DarkSkeleton } from '@eika/skeleton';

import { useConfig } from '../../defaultConfig';
import { AccountId, InterestRates } from '../../generated-types';
import { useTranslation } from '../../translations';
import { format } from '../../translations/useTranslation';
import { kredittbankenTrackingIDs } from '../../utils/gtm/kredittbankenTrackingIds';

import './LoanInterest.scss';

interface Props {
    interestRates?: InterestRates;
    isLoading: boolean;
    accountId?: AccountId;
}

const LoanInterest: React.FC<Props> = ({ interestRates, isLoading, accountId }) => {
    const { loanInterest: translated } = useTranslation();
    const {
        links: { repaymentPlan },
    } = useConfig();
    if (isLoading) {
        return (
            <>
                <DarkSkeleton height={210} className="loan-interest--skeleton" />
                <DarkSkeleton height={96} className="link-card--skeleton" />
            </>
        );
    }
    if (!interestRates) return null;
    return (
        <>
            <div className="loan-interest">
                <dl>
                    <dt className="typography-subtitle">{translated.nominalInterest}</dt>
                    <dd className="loan-interest__value">{interestRates.nominalInterestRate}%</dd>
                </dl>
                {!!interestRates.effectiveInterestRate && (
                    <p>{format(translated.effectiveInterest, interestRates.effectiveInterestRate)}</p>
                )}
            </div>
            {!!repaymentPlan && !!accountId && (
                <LinkCard
                    url={format(repaymentPlan.url, accountId.toString())}
                    title={translated.loanRepaymentLinkTitle}
                    icon={IconTypes.OYE_24}
                    textOne={translated.loanRepaymentLinkDescription}
                    data-track-id={kredittbankenTrackingIDs.repaymentPlan}
                    data-track-linkname={translated.loanRepaymentLinkTitle}
                />
            )}
        </>
    );
};

export default LoanInterest;
